export default __webpack_public_path__ + "static/media/logo.c1e5f61b.svg";